import React, { useState } from "react";
import SaveButton from "../../../components/Buttons/SaveButton";
import Popup from "../../../components/Popups/Popup";
import { useNotifications } from "../../../contexts/notificationContext";
import AttachmentTypeModel from "../../../models/AttachmentTypeModel";
import DataService from "../../../services/data.service";
import { PopupProps } from "../../../types/PopupProps";
import { Result } from "../../../types/Result";
import FormatUtils from "../../../utils/FormatUtils";
import AttachmentTypeControl from "../Components/AttachmentTypeControl";

const AddAttachmentTypePopup: React.FC<PopupProps> = ({ show, onHide }) => {
    const [serverErrors, setServerErrors] = useState<Result>();
    const { handleResult, handleException } = useNotifications();
    const [submitCount, setSubmitCount] = useState(0)

    const [formData] = useState<AttachmentTypeModel>({
        id: 0,
        name: '',
        isGeneratable: false,
        forLicense: false,
        forUser: false,
        forBom: false,
        beginDate: new FormatUtils().formatDateForStorage(new Date()),
        endDate: '',
        canDelete: true,
        isSearchable: true,
        businessPartnerTypeIds: [],
        itemTypeIds: [],
        projectTypeIds: [],
        concurrencyId: ''
    });

    function submit() {
        DataService
            .create<AttachmentTypeModel>(`api/v1/attachmentTypes/`, formData)
            .then(response => {
                handleResult(response);
                setServerErrors(response);
                if (response.isSuccesful === true)
                    onHide();
            })
            .catch(e => handleException(e));
    }

    return (
        <Popup show={show} onHide={onHide} size={'lg'} title={'Add Attachment type'} >
            <Popup.Body>
                <AttachmentTypeControl formData={formData} handleSubmit={submit} serverErrors={serverErrors} submitCount={submitCount} />
            </Popup.Body>
            <Popup.Footer>
                <SaveButton onClick={() => { setSubmitCount(x => x + 1)}} />
            </Popup.Footer>
        </Popup>
    );
}
export default AddAttachmentTypePopup;